'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var _SHARE = require('components/SHARE');

var _helpers = require('helpers');

var _components2 = require('components');

require('./OrderItemsDetailView.less');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _windowOrGlobal = require('window-or-global');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    OrderItemsDetail: {
        displayName: 'OrderItemsDetail'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Order/default/OrderItemsDetailView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

function LinkPay(_ref) {
    var onPay = _ref.onPay,
        disabled = _ref.disabled,
        lang = _ref.lang;

    return _react3.default.createElement(
        'div',
        { className: 'buttons-holder' },
        _react3.default.createElement(
            'button',
            { disabled: disabled, onClick: onPay, className: 'le-button big' },
            lang['store.common.pay']
        )
    );
}

var OrderItemsDetail = _wrapComponent('OrderItemsDetail')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(OrderItemsDetail, _Component);

    function OrderItemsDetail(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, OrderItemsDetail);

        var _this = (0, _possibleConstructorReturn3.default)(this, (OrderItemsDetail.__proto__ || (0, _getPrototypeOf2.default)(OrderItemsDetail)).call(this, props));

        _this.onPay = function (event) {
            event.preventDefault();
            _this.props.onPay();
        };

        _this.editOrder = function (event) {
            event.preventDefault();
            _this.props.editOrder();
        };

        _this.cancelOrder = function (event) {
            event.preventDefault();
            _this.props.cancelOrder();
        };

        _this.renderTitleProduct = function (_ref2) {
            var product = _ref2.product,
                is_coupon = _ref2.is_coupon;

            var offer = product.offer;
            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'div',
                    { className: 'title' },
                    _react3.default.createElement(
                        _reactRouter.Link,
                        { to: '/product/' + offer.id },
                        offer.name
                    )
                ),
                _react3.default.createElement(_SHARE.SwitherDescription, { description: offer.description }),
                product.custom_fields ? product.custom_fields.map(function (item, i) {
                    return _react3.default.createElement(
                        'label',
                        null,
                        item.name,
                        ': ',
                        item.value
                    );
                }) : null
            );
        };

        _this.renderTitleModifierOptionName = function (_ref3) {
            var offer = _ref3.offer;

            if (offer.modifier_option_name !== null && offer.modifier_option_name !== '') {
                return _react3.default.createElement(
                    'div',
                    { className: 'title' },
                    offer.modifier_option_name
                );
            } else if (offer.modifier_option_id !== null) {
                return _react3.default.createElement(
                    'div',
                    { className: 'title' },
                    offer.modifiedOption.name
                );
            } else {
                return _react3.default.createElement('div', { className: 'title' });
            }
        };

        _this.renderDate = function (_ref4) {
            var date = _ref4.date;

            date = (0, _moment2.default)(date);

            return _react3.default.createElement(
                'div',
                { className: 'date' },
                _react3.default.createElement(
                    'span',
                    null,
                    date.format('DD.MM.YYYY')
                )
            );
        };

        _this.renderSum = function (_ref5) {
            var sum = _ref5.sum;
            var currency = _this.props.currency;

            return _react3.default.createElement(
                'div',
                { className: 'price' },
                _react3.default.createElement(_components2.MoneyValue, {
                    value: sum,
                    icon: currency.icon,
                    iconAfterValue: currency.icon_after_value
                })
            );
        };

        _this.renderProduct = function (item, index) {
            var price = parseFloat(item.base_price);
            var itemQty = item.refundedProduct && _this.props.isRevert ? item.refundedProduct.quantity : item.quantity;
            var quantity = parseInt(item.quantity, 10) || 0;
            var quantityForChilds = parseInt(itemQty, 10) || 0;
            var pictures = item.offer.pictures || [];
            var image = pictures[0];
            var weight = null;
            var childWeight = null;
            return _react3.default.createElement(
                'div',
                { key: index, className: 'row no-margin cart-item' },
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-1 col-xs-12' },
                    image && image.preview_url ? _react3.default.createElement('img', { src: image.preview_url }) : ''
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-4' },
                    _react3.default.createElement(_this2.renderTitleProduct, { product: item, is_coupon: item.is_coupon || item.isCoupon })
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-3' },
                    _react3.default.createElement(_this2.renderTitleModifierOptionName, { offer: item })
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-2 hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'quantity cart_quantity' },
                        _react3.default.createElement(
                            'span',
                            null,
                            quantity
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-2 hidden-xs' },
                    _react3.default.createElement(_this2.renderSum, { sum: price * quantity })
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-2 visible-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'quantity cart_quantity', style: { textAlign: 'left' } },
                        _react3.default.createElement(
                            'span',
                            null,
                            _this.props.lang['store.common.quantity'],
                            ': ',
                            quantity
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-2 visible-xs price', style: { textAlign: 'left' } },
                    _react3.default.createElement(
                        'span',
                        { className: 'visible-xs' },
                        _this.props.lang['store.common.price'],
                        ': ',
                        _react3.default.createElement(_components2.MoneyValue, {
                            value: price * quantity,
                            icon: _this.props.currency.icon,
                            iconAfterValue: _this.props.currency.icon_after_value
                        })
                    )
                ),
                item.type_id === 5 ? item.childProducts.map(function (childItem) {
                    return _this.renderNested(childItem, quantityForChilds);
                }) : null
            );
        };

        _this.renderNested = function (childItem, quantity) {
            var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

            if (childItem.quantity == 0) {
                return null;
            }
            var weight = childItem.quantity / quantity;
            childItem.weight_offer = childItem.weight_offer * 1;
            if ((childItem.unit.slug === 'kg' || childItem.unit.slug === 'mg') && childItem.weight_offer && childItem.weight_offer > 0 && childItem.quantity > 0) {
                weight = childItem.weight_offer * childItem.quantity / quantity;
                weight = weight.toFixed(3);
                if (childItem.weight_offer < 0.01 && childItem.quantity < 1 || childItem.weight_offer < 1 && childItem.quantity < 0.01) {
                    weight = item.weight_offer * 1;
                }
                if (childItem.weight_offer < 0.1 && childItem.quantity < 0.1) {
                    weight = childItem.weight_offer * 1;
                }
            }
            var paddingLeft = level * 30 + 'px';
            return _react3.default.createElement(
                'div',
                { className: 'row no-margin', style: { clear: 'both' } },
                _react3.default.createElement('div', { className: 'col-sm-1 col-xs-12' }),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-4 visible-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title', style: { paddingLeft: paddingLeft } },
                        '- ',
                        childItem.name,
                        ' ',
                        childItem.modifier_option_name
                    ),
                    _react3.default.createElement(
                        'div',
                        { style: { paddingLeft: '30px' } },
                        _react3.default.createElement(
                            'span',
                            null,
                            _this.props.lang['store.common.quantity'],
                            ': '
                        ),
                        childItem.type_id === 5 ? _react3.default.createElement(
                            'span',
                            null,
                            childItem.quantity / quantity
                        ) : _react3.default.createElement(
                            'span',
                            null,
                            weight,
                            ' ',
                            _this.props.lang[childItem.unit.title_lang_data]
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-4 hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title', style: { paddingLeft: paddingLeft } },
                        '- ',
                        childItem.name
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-3 hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title' },
                        childItem.modifier_option_name
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-2 hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { style: { textAlign: 'center' } },
                        _react3.default.createElement(
                            'span',
                            { className: 'visible-xs' },
                            _this.props.lang['store.common.quantity'],
                            ': '
                        ),
                        childItem.type_id === 5 ? _react3.default.createElement(
                            'span',
                            null,
                            childItem.quantity / quantity
                        ) : _react3.default.createElement(
                            'span',
                            null,
                            weight,
                            ' ',
                            _this.props.lang[childItem.unit.title_lang_data]
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-2' },
                    _react3.default.createElement('div', { className: 'price' })
                ),
                childItem.type_id === 5 ? childItem.childProducts.map(function (childChildItem) {
                    return _this.renderNested(childChildItem, quantity, level + 1);
                }) : null
            );
        };

        _this.renderButtonAndStatusPay = function () {
            var _this$props = _this.props,
                _this$props$showPay = _this$props.showPay,
                showPay = _this$props$showPay === undefined ? false : _this$props$showPay,
                _this$props$hidePayBu = _this$props.hidePayButton,
                hidePayButton = _this$props$hidePayBu === undefined ? false : _this$props$hidePayBu,
                _this$props$disabled = _this$props.disabled,
                disabled = _this$props$disabled === undefined ? true : _this$props$disabled,
                lang = _this$props.lang;

            if (showPay) {
                if (hidePayButton) {
                    return null;
                }
                return _react3.default.createElement(LinkPay, { onPay: _this.onPay, disabled: disabled, lang: lang });
            }
            return null;
        };

        _this.renderSumPrice = function () {
            var AccountsList = _this.props.user.amount[0];
            var coupons = _this.props.user.coupons;

            var _this$props2 = _this.props,
                sum = _this$props2.sum,
                showPay = _this$props2.showPay,
                _this$props2$hideAll = _this$props2.hideAll,
                hideAll = _this$props2$hideAll === undefined ? false : _this$props2$hideAll,
                bonusValue = _this$props2.bonusValue,
                paymentInId = _this$props2.paymentInId,
                sumDiscount = _this$props2.sumDiscount,
                setting = _this$props2.setting,
                currency = _this$props2.currency,
                lang = _this$props2.lang;

            var discountSum = (sum - sumDiscount) / 2;
            if (_this.props.ibonus_data) {
                var IBonusData = _windowOrGlobal.JSON.parse(_this.props.ibonus_data);
                if (IBonusData.discount_sum && IBonusData.discount_sum > discountSum) {
                    discountSum = IBonusData.discount_sum * 1;
                }
            }
            var addAmount = 0;
            if (sumDiscount > 0) {
                addAmount = sumDiscount * 1;
            }
            if (AccountsList.amount + addAmount > 0 && AccountsList.amount + addAmount < discountSum) {
                discountSum = AccountsList.amount * 1 + addAmount;
            }
            if (sum - discountSum < 1) {
                discountSum = sum - 1;
                if (discountSum < 0) discountSum = 0;
            }
            discountSum = Math.floor(discountSum);
            var totalSum = sum - sumDiscount - bonusValue;
            var sumTotal = sum - sumDiscount;
            var text = lang['store.cart.total'] + ': ';
            var cashbackValue = '';
            var couponsSlider = '';
            var cashbackCoupon = '';
            var useCoupon = false;
            _this.props.products.forEach(function (item) {
                if (item.is_coupon === true) {
                    useCoupon = true;
                }
            });
            var sumDiscountAmount = '';
            if (sumDiscount > 0) {
                sumDiscountAmount = _react3.default.createElement(
                    'div',
                    { className: 'items-holder' },
                    _react3.default.createElement(_components2.MoneyValue, {
                        value: parseFloat(sumDiscount),
                        icon: currency.icon,
                        iconAfterValue: currency.icon_after_value,
                        prefix: lang['store.common.discountInOrder'] + ': '
                    })
                );
            }
            setting.loyaltySettingsData = _this.props.user.loyaltySettings;
            if (setting.loyaltySettingsActive && !hideAll && setting.loyaltySettingsData.customerSettings !== undefined && setting.loyaltySettingsData.newCustomerSettings !== undefined) {
                if (AccountsList.notFirstOrder !== true) {
                    if (setting.loyaltySettingsData.newCustomerSettings.coupon !== null && setting.loyaltySettingsData.newCustomerSettings.coupon !== undefined && setting.loyaltySettingsData.newCustomerSettings.coupon.deleted !== true) {
                        cashbackCoupon = _react3.default.createElement(
                            'div',
                            null,
                            lang['store.iBonus.order.afterPaymentCoupon'],
                            _react3.default.createElement(
                                'div',
                                { className: 'text-center', style: { maxWidth: '100px', border: '4px solid #008000', borderRadius: '8px', marginLeft: 'auto', marginRight: 'auto' } },
                                setting.loyaltySettingsData.newCustomerSettings.coupon.imagePath !== null ? _react3.default.createElement(
                                    'div',
                                    { className: 'text-center', style: { padding: '4px' } },
                                    _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px', marginLeft: 'auto', marginRight: 'auto' }, src: setting.loyaltySettingsData.newCustomerSettings.coupon.imagePath })
                                ) : _react3.default.createElement('div', { style: { width: '72px', height: '72px', padding: '4px' } }),
                                _react3.default.createElement(
                                    'div',
                                    null,
                                    setting.loyaltySettingsData.newCustomerSettings.coupon.header
                                )
                            )
                        );
                    }
                    if (setting.loyaltySettingsData.newCustomerSettings.cashBackType === 'percentage') {
                        cashbackValue = _react3.default.createElement(
                            'div',
                            { className: 'row no-margin summ_row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 text-center' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'total_price' },
                                    lang['store.iBonus.order.afterPaymentPointsFirstOrder'],
                                    ' ',
                                    (totalSum / 100 * setting.loyaltySettingsData.newCustomerSettings.amount).toFixed(2),
                                    '      ',
                                    lang['store.iBonus.order.points']
                                ),
                                cashbackCoupon
                            )
                        );
                    } else {
                        cashbackValue = _react3.default.createElement(
                            'div',
                            { className: 'row no-margin summ_row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 text-center' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'total_price' },
                                    lang['store.iBonus.order.afterPaymentPointsFirstOrder'],
                                    ' ',
                                    setting.loyaltySettingsData.newCustomerSettings.amount,
                                    '      ',
                                    lang['store.iBonus.order.points']
                                ),
                                cashbackCoupon
                            )
                        );
                    }
                } else {
                    if (setting.loyaltySettingsData.customerSettings.coupon !== null && setting.loyaltySettingsData.customerSettings.coupon !== undefined && setting.loyaltySettingsData.customerSettings.coupon.deleted !== true) {
                        cashbackCoupon = _react3.default.createElement(
                            'div',
                            null,
                            lang['store.iBonus.order.afterPaymentCoupon'],
                            _react3.default.createElement(
                                'div',
                                { style: { maxWidth: '100px', border: '4px solid #008000', borderRadius: '8px', marginLeft: 'auto', marginRight: 'auto' } },
                                setting.loyaltySettingsData.customerSettings.coupon.imagePath !== null ? _react3.default.createElement(
                                    'div',
                                    { className: 'text-center', style: { padding: '4px' } },
                                    _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px', marginLeft: 'auto', marginRight: 'auto' }, src: setting.loyaltySettingsData.customerSettings.coupon.imagePath })
                                ) : _react3.default.createElement('div', { style: { width: '72px', height: '72px', padding: '4px' } }),
                                _react3.default.createElement(
                                    'div',
                                    null,
                                    setting.loyaltySettingsData.customerSettings.coupon.header
                                )
                            )
                        );
                    }
                    if (setting.loyaltySettingsData.customerSettings.cashBackType === 'percentage') {
                        cashbackValue = _react3.default.createElement(
                            'div',
                            { className: 'row no-margin summ_row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 text-center' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'total_price' },
                                    lang['store.iBonus.order.afterPaymentPoints'],
                                    ' ',
                                    (totalSum / 100 * setting.loyaltySettingsData.customerSettings.amount).toFixed(2),
                                    ' ',
                                    lang['store.iBonus.order.points']
                                ),
                                cashbackCoupon
                            )
                        );
                    } else {
                        cashbackValue = _react3.default.createElement(
                            'div',
                            { className: 'row no-margin summ_row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 text-center' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'total_price' },
                                    lang['store.iBonus.order.afterPaymentPoints'],
                                    ' ',
                                    setting.loyaltySettingsData.customerSettings.amount,
                                    ' ',
                                    lang['store.iBonus.order.points']
                                ),
                                cashbackCoupon
                            )
                        );
                    }
                }
                if (coupons.length > 0) {
                    var couponStyleSelect = '';
                    couponsSlider = _react3.default.createElement(
                        'div',
                        { className: 'row no-margin summ_row' },
                        _react3.default.createElement(
                            'div',
                            { className: 'total_price' },
                            lang['store.iBonus.order.availableCoupons']
                        ),
                        _react3.default.createElement(
                            'div',
                            { style: { overflow: 'auto' } },
                            _react3.default.createElement(
                                'table',
                                null,
                                _react3.default.createElement(
                                    'tbody',
                                    null,
                                    _react3.default.createElement(
                                        'tr',
                                        { key: 1 },
                                        coupons.map(function (item, index) {
                                            couponStyleSelect = '4px solid #fff';
                                            if (_this.props.couponId === item.id) {
                                                couponStyleSelect = '4px solid #008000';
                                            }
                                            if (item.imagePath !== null) {
                                                return _react3.default.createElement(
                                                    'td',
                                                    { style: { padding: '8px' } },
                                                    _react3.default.createElement(
                                                        'div',
                                                        { className: 'text-center', style: { border: couponStyleSelect, borderRadius: '8px' } },
                                                        _react3.default.createElement(
                                                            'a',
                                                            { onClick: function onClick(e) {
                                                                    _this.props.couponSelect(item);
                                                                } },
                                                            _react3.default.createElement(
                                                                'div',
                                                                { style: { maxWidth: '72px', maxHeight: '72px', padding: '4px' } },
                                                                _react3.default.createElement('img', { style: { maxWidth: '68px', maxHeight: '68px' }, src: item.imagePath })
                                                            ),
                                                            _react3.default.createElement(
                                                                'div',
                                                                null,
                                                                item.header
                                                            )
                                                        )
                                                    )
                                                );
                                            } else {
                                                return _react3.default.createElement(
                                                    'td',
                                                    { style: { padding: '8px' } },
                                                    _react3.default.createElement(
                                                        'div',
                                                        { className: 'text-center', style: { border: couponStyleSelect, borderRadius: '8px' } },
                                                        _react3.default.createElement(
                                                            'a',
                                                            { onClick: function onClick(e) {
                                                                    _this.props.couponSelect(item);
                                                                } },
                                                            _react3.default.createElement('div', { style: { width: '72px', height: '72px', padding: '4px' } }),
                                                            _react3.default.createElement(
                                                                'div',
                                                                null,
                                                                item.header
                                                            )
                                                        )
                                                    )
                                                );
                                            }
                                        })
                                    )
                                )
                            )
                        )
                    );
                }
            }
            if (hideAll) {
                setting.loyaltySettingsActive = false;
            }
            return _react3.default.createElement(
                'div',
                null,
                setting.loyaltySettingsActive && AccountsList.amount > 0 && sum !== '0.00000000' && showPay && !hideAll ? _react3.default.createElement(
                    'div',
                    null,
                    couponsSlider,
                    AccountsList.amount > 0 && !hideAll ? _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-12' },
                                lang['store.iBonus.order.bonusesToUseAreAvailable'],
                                ' ',
                                (AccountsList.amount * 1 + addAmount).toFixed(2)
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-2' },
                                lang['store.iBonus.order.bonusesUse']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-6' },
                                _react3.default.createElement('input', { type: 'range', min: 0, max: discountSum, step: 1, value: bonusValue, onChange: _this.props.onChangeBonusValue })
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            _react3.default.createElement('div', { className: 'col-xs-12 col-sm-2' }),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-3' },
                                '0'
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-3 text-right' },
                                discountSum
                            )
                        )
                    ) : null,
                    cashbackValue,
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 text-center' },
                        _react3.default.createElement(
                            'div',
                            { className: 'summ_price items-holder' },
                            sumDiscountAmount,
                            _react3.default.createElement(_components2.MoneyValue, {
                                value: parseFloat(totalSum),
                                icon: currency.icon,
                                iconAfterValue: currency.icon_after_value,
                                prefix: text
                            })
                        )
                    )
                ) : null,
                setting.loyaltySettingsActive && paymentInId !== null && !showPay ? _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 text-center' },
                        _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-12' },
                                lang['store.iBonus.order.bonusesUsed'],
                                ' ',
                                parseFloat(sumDiscount).toFixed(2),
                                ' ',
                                lang['store.iBonus.order.bonuses']
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 text-center' },
                        _react3.default.createElement(
                            'div',
                            { className: 'summ_price' },
                            sumDiscountAmount,
                            _react3.default.createElement(_components2.MoneyValue, {
                                value: parseFloat(sumTotal),
                                icon: currency.icon,
                                iconAfterValue: currency.icon_after_value,
                                prefix: text
                            })
                        )
                    )
                ) : null,
                !setting.loyaltySettingsActive ? _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 text-center' },
                    _react3.default.createElement(
                        'div',
                        { className: 'summ_price' },
                        sumDiscountAmount,
                        _react3.default.createElement(_components2.MoneyValue, {
                            value: parseFloat(sum - sumDiscount),
                            icon: currency.icon,
                            iconAfterValue: currency.icon_after_value,
                            prefix: text
                        })
                    )
                ) : null
            );
        };

        _this.renderMergedOrder = function () {
            var _this$props3 = _this.props,
                url = _this$props3.url,
                sum = _this$props3.sum,
                _this$props3$before = _this$props3.before,
                before = _this$props3$before === undefined ? null : _this$props3$before,
                _this$props3$after = _this$props3.after,
                after = _this$props3$after === undefined ? null : _this$props3$after,
                _this$props3$showPay = _this$props3.showPay,
                showPay = _this$props3$showPay === undefined ? false : _this$props3$showPay,
                token = _this$props3.token,
                _this$props3$paymentL = _this$props3.paymentList,
                paymentList = _this$props3$paymentL === undefined ? null : _this$props3$paymentL,
                _this$props3$hideAll = _this$props3.hideAll,
                hideAll = _this$props3$hideAll === undefined ? false : _this$props3$hideAll,
                lang = _this$props3.lang,
                setting = _this$props3.setting,
                delivery_address = _this$props3.delivery_address,
                userAddresses = _this$props3.userAddresses,
                addresses = _this$props3.addresses,
                client_comment = _this$props3.client_comment,
                onDeliveryAddressChange = _this$props3.onDeliveryAddressChange,
                onDeliveryAddressSave = _this$props3.onDeliveryAddressSave,
                onClientCommentChange = _this$props3.onClientCommentChange,
                onAddAddress = _this$props3.onAddAddress,
                isOrderWasPaid = _this$props3.isOrderWasPaid,
                isRevert = _this$props3.isRevert,
                currency = _this$props3.currency,
                order_type_id = _this$props3.order_type_id,
                childOrders = _this$props3.childOrders;

            return _react3.default.createElement(
                'div',
                { style: { paddingLeft: '10px' }, className: 'col-xs-12 no-margin personal-order-detail' },
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 items-holder no-margin' },
                    _react3.default.createElement(
                        'div',
                        { className: 'row no-margin summ_row' },
                        _react3.default.createElement(
                            'h4',
                            null,
                            lang['store.postpone.combinesOrders'],
                            ':'
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'row no-margin cart-item hidden-xs' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-9 text-center' },
                                lang['store.common.order']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-3 text-center' },
                                lang['store.common.sum']
                            )
                        ),
                        childOrders.map(function (childOrder) {
                            return _react3.default.createElement(
                                'div',
                                { className: 'row no-margin cart-item hidden-xs' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-sm-9 text-center' },
                                    _react3.default.createElement(
                                        _reactRouter.Link,
                                        { to: '/personal/order/' + childOrder.id },
                                        childOrder.order_number
                                    )
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-sm-3 text-center' },
                                    _react3.default.createElement(_components2.MoneyValue, {
                                        value: childOrder.sum,
                                        icon: currency.icon,
                                        iconAfterValue: currency.icon_after_value
                                    })
                                )
                            );
                        })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'row no-margin summ_row' },
                        _react3.default.createElement(
                            'div',
                            { className: 'col-sm-12 hidden-xs' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-7 col-md-8' },
                                !showPay && !hideAll && sum !== '0.00000000' ? _react3.default.createElement(
                                    'button',
                                    {
                                        className: 'le-button receipt',
                                        onClick: function onClick() {
                                            return (0, _helpers.getCheckByOrder)(_this.props);
                                        },
                                        title: lang['store.order_items_detail.get_check']
                                    },
                                    lang['store.order_items_detail.check']
                                ) : null
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 text-center' },
                            _react3.default.createElement(
                                'div',
                                { className: 'summ_price items-holder' },
                                _react3.default.createElement(_components2.MoneyValue, {
                                    value: parseFloat(sum),
                                    icon: _this.props.currency.icon,
                                    iconAfterValue: _this.props.currency.icon_after_value,
                                    prefix: lang['store.cart.total']
                                })
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 hidden-sm hidden-lg hidden-md' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12' },
                                !showPay && !hideAll && sum !== '0.00000000' ? _react3.default.createElement(
                                    'button',
                                    {
                                        className: 'le-button receipt',
                                        onClick: function onClick() {
                                            return (0, _helpers.getCheckByOrder)(_this.props);
                                        },
                                        title: lang['store.order_items_detail.get_check']
                                    },
                                    lang['store.order_items_detail.check']
                                ) : null
                            )
                        )
                    ),
                    paymentList && showPay && !hideAll ? _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(
                            'div',
                            { className: 'row', style: { paddingLeft: '10px' } },
                            _react3.default.createElement('div', { className: 'col-xs-12 col-sm-9' }),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-3 text-center' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'buttons-holder' },
                                    _react3.default.createElement(
                                        'button',
                                        { onClick: _this.cancelOrder, className: 'le-button' },
                                        lang['store.common.cancelOrder.button.cancelOrder']
                                    )
                                )
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'row', style: { paddingLeft: '10px' } },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-8' },
                                paymentList
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-4 col-xs-12 text-center' },
                                _this.renderButtonAndStatusPay()
                            )
                        )
                    ) : null
                )
            );
        };

        return _this;
    }

    (0, _createClass3.default)(OrderItemsDetail, [{
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                url = _props.url,
                _props$products = _props.products,
                products = _props$products === undefined ? [] : _props$products,
                sum = _props.sum,
                _props$before = _props.before,
                before = _props$before === undefined ? null : _props$before,
                _props$after = _props.after,
                after = _props$after === undefined ? null : _props$after,
                _props$showPay = _props.showPay,
                showPay = _props$showPay === undefined ? false : _props$showPay,
                token = _props.token,
                _props$paymentList = _props.paymentList,
                paymentList = _props$paymentList === undefined ? null : _props$paymentList,
                orderDate = _props.orderDate,
                _props$hideAll = _props.hideAll,
                hideAll = _props$hideAll === undefined ? false : _props$hideAll,
                lang = _props.lang,
                setting = _props.setting,
                delivery_address = _props.delivery_address,
                userAddresses = _props.userAddresses,
                addresses = _props.addresses,
                client_comment = _props.client_comment,
                onDeliveryAddressChange = _props.onDeliveryAddressChange,
                onDeliveryAddressSave = _props.onDeliveryAddressSave,
                onClientCommentChange = _props.onClientCommentChange,
                onAddAddress = _props.onAddAddress,
                isOrderWasPaid = _props.isOrderWasPaid,
                isRevert = _props.isRevert,
                order_type_id = _props.order_type_id;


            var date = (0, _moment2.default)(orderDate);

            var commentFieldPlaceholderDefaultValue = lang['store.order_items.comment_field_placeholder'];
            var commentFieldTitleDefaultValue = lang['store.order_items.comment_field_title'];

            // setting.deliveryFieldShow = true;

            var _setting$commentField = setting.commentFieldPlaceholder,
                commentFieldPlaceholder = _setting$commentField === undefined ? commentFieldPlaceholderDefaultValue : _setting$commentField,
                commentFieldShow = setting.commentFieldShow,
                deliveryFieldShow = setting.deliveryFieldShow,
                _setting$commentField2 = setting.commentFieldTitle,
                commentFieldTitle = _setting$commentField2 === undefined ? commentFieldTitleDefaultValue : _setting$commentField2;


            if (order_type_id === 7) {
                return _react3.default.createElement(
                    'div',
                    { className: 'personal-order-detail' },
                    _react3.default.createElement(
                        'h2',
                        { className: 'section-title special_title', style: { paddingLeft: '10px' } },
                        _react3.default.createElement(
                            'span',
                            null,
                            lang['store.common.order'],
                            ' \u2116 ',
                            this.props.order_number
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'excerpt special_status' },
                            _react3.default.createElement(
                                'div',
                                { className: 'status-payment' },
                                this.props.payStatus
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'h5',
                        { style: { paddingLeft: '10px' } },
                        '' + date.format('DD.MM.YYYY')
                    ),
                    this.renderMergedOrder()
                );
            }

            return _react3.default.createElement(
                'div',
                { className: 'personal-order-detail' },
                _react3.default.createElement(
                    'h2',
                    { className: 'section-title special_title', style: { paddingLeft: '10px' } },
                    _react3.default.createElement(
                        'span',
                        null,
                        lang['store.common.order'],
                        ' \u2116 ',
                        this.props.order_number
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'excerpt special_status' },
                        _react3.default.createElement(
                            'div',
                            { className: 'status-payment' },
                            this.props.payStatus
                        )
                    )
                ),
                _react3.default.createElement(
                    'h5',
                    { style: { paddingLeft: '10px' } },
                    '' + date.format('DD.MM.YYYY')
                ),
                _react3.default.createElement(
                    'div',
                    { style: { paddingLeft: '10px' }, className: 'col-xs-12 no-margin personal-order-detail' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 items-holder no-margin' },
                        _react3.default.createElement(
                            'div',
                            { className: 'row no-margin cart-item hidden-xs' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-1' },
                                lang['store.cart.photo']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                lang['store.cart.title']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-3' },
                                lang['store.cart.modifiers']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-2 text-center' },
                                lang['store.cart.quantity']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-2 text-center' },
                                lang['store.cart.price']
                            )
                        ),
                        products.map(this.renderProduct),
                        _react3.default.createElement(
                            'div',
                            { className: 'row no-margin summ_row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-12 hidden-xs' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-sm-7 col-md-8' },
                                    !showPay && !hideAll && sum !== '0.00000000' ? _react3.default.createElement(
                                        'button',
                                        {
                                            className: 'le-button receipt',
                                            onClick: function onClick() {
                                                return (0, _helpers.getCheckByOrder)(_this3.props);
                                            },
                                            title: lang['store.order_items_detail.get_check']
                                        },
                                        lang['store.order_items_detail.check']
                                    ) : null
                                ),
                                _react3.default.createElement(
                                    'div',
                                    null,
                                    this.renderSumPrice()
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 hidden-sm hidden-lg hidden-md' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-xs-12' },
                                    this.renderSumPrice()
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-xs-12' },
                                    !showPay && !hideAll && sum !== '0.00000000' ? _react3.default.createElement(
                                        'button',
                                        {
                                            className: 'le-button receipt',
                                            onClick: function onClick() {
                                                return (0, _helpers.getCheckByOrder)(_this3.props);
                                            },
                                            title: lang['store.order_items_detail.get_check']
                                        },
                                        lang['store.order_items_detail.check']
                                    ) : null
                                )
                            )
                        ),
                        deliveryFieldShow ? _react3.default.createElement(
                            'div',
                            { className: 'row', style: { paddingLeft: '15px' } },
                            !showPay && !hideAll && sum !== '0.00000000' ? _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                { className: 'col-xs-12 col-sm-7' },
                                _react3.default.createElement(
                                    _reactBootstrap.FormGroup,
                                    { className: 'col-xs-12 col-sm-7' },
                                    delivery_address !== '' && delivery_address !== null ? _react3.default.createElement(
                                        _reactBootstrap.ControlLabel,
                                        null,
                                        lang['store.common.delivery_address']
                                    ) : null,
                                    delivery_address !== '' && delivery_address !== null ? _react3.default.createElement(
                                        'div',
                                        null,
                                        delivery_address
                                    ) : null
                                )
                            ) : _react3.default.createElement(_components2.AddressInput, {
                                isOrderWasPaid: isOrderWasPaid,
                                placeholder: lang['store.common.delivery_address_placeholder'],
                                value: delivery_address,
                                options: addresses,
                                label: lang['store.common.delivery_address'],
                                buttonText: lang['store.common.select_on_map'],
                                buttonAddAddressText: lang['user.address.button.addNewAddress'],
                                noOptionsMessageText: lang['user.address.noAddress'],
                                onAddressChange: onDeliveryAddressChange,
                                onAddressSave: onDeliveryAddressSave,
                                onAddAddress: onAddAddress
                            })
                        ) : null,
                        commentFieldShow ? _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            !showPay && !hideAll && sum !== '0.00000000' ? _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                { className: 'col-xs-12 col-sm-7' },
                                client_comment !== '' && client_comment !== null ? _react3.default.createElement(
                                    _reactBootstrap.ControlLabel,
                                    null,
                                    commentFieldTitle
                                ) : null,
                                client_comment !== '' && client_comment !== null ? _react3.default.createElement(
                                    'div',
                                    null,
                                    client_comment
                                ) : null
                            ) : _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                { className: 'col-xs-12 col-sm-7' },
                                _react3.default.createElement(
                                    _reactBootstrap.ControlLabel,
                                    null,
                                    commentFieldTitle
                                ),
                                _react3.default.createElement(_reactBootstrap.FormControl, {
                                    value: client_comment,
                                    type: 'text',
                                    placeholder: commentFieldPlaceholder,
                                    onChange: onClientCommentChange,
                                    componentClass: 'textarea',
                                    className: 'textarea_disable-resize'
                                })
                            )
                        ) : null,
                        paymentList && showPay && !hideAll ? _react3.default.createElement(
                            'div',
                            null,
                            _react3.default.createElement(
                                'div',
                                { className: 'row', style: { paddingLeft: '10px' } },
                                _react3.default.createElement('div', { className: 'col-xs-12 col-sm-6' }),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-sm-3 col-xs-12 text-right' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'buttons-holder' },
                                        _react3.default.createElement(
                                            'button',
                                            { onClick: this.editOrder, className: 'le-button' },
                                            lang['store.common.editOrder.button.editOrder']
                                        )
                                    )
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-xs-12 col-sm-3 text-center' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'buttons-holder' },
                                        _react3.default.createElement(
                                            'button',
                                            { onClick: this.cancelOrder, className: 'le-button' },
                                            lang['store.common.cancelOrder.button.cancelOrder']
                                        )
                                    )
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'row', style: { paddingLeft: '10px' } },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-xs-12 col-sm-8' },
                                    paymentList
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-sm-4 col-xs-12 text-center' },
                                    this.renderButtonAndStatusPay()
                                )
                            )
                        ) : null
                    )
                )
            );
        }
    }]);
    return OrderItemsDetail;
}(_react2.Component), _class.propTypes = {
    isOrderWasPaid: _react2.PropTypes.bool.isRequired,
    onPay: _react2.PropTypes.func.isRequired,
    paymentList: _react2.PropTypes.any,
    hidePayButton: _react2.PropTypes.bool,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object,
    setting: _react2.PropTypes.object.isRequired,
    delivery_address: _react2.PropTypes.string.isRequired,
    addresses: _react2.PropTypes.array.isRequired,
    client_comment: _react2.PropTypes.string.isRequired,
    onDeliveryAddressChange: _react2.PropTypes.func.isRequired,
    onDeliveryAddressSave: _react2.PropTypes.func.isRequired,
    onClientCommentChange: _react2.PropTypes.func.isRequired,
    onAddAddress: _react2.PropTypes.func.isRequired,
    isRevert: _react2.PropTypes.bool.isRequired
}, _class.defaultProps = {
    hidePayButton: false
}, _temp));

exports.default = OrderItemsDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/default/OrderItemsDetailView.jsx
// module id = 1713
// module chunks = 0